import { AudioLines, Volume2 } from 'lucide-react'
import { ProviderTypes } from '../../config/agent-settings.validation.config'
import SelectedLabel from './selected-label'

// Shared language configuration for audio prompt component
export const BASIC_LANGUAGES = [
  { label: 'Dutch', value: 'nl-NL', shortCode: 'NL' },
  { label: 'English (Australia)', value: 'en-AU', shortCode: 'En(AU)' },
  { label: 'English UK', value: 'en-GB', shortCode: 'En(GB)' },
  { label: 'English US', value: 'en-US', shortCode: 'En(US)' },
  { label: 'French', value: 'fr-FR', shortCode: 'FR' },
  { label: 'German', value: 'de-DE', shortCode: 'DE' },
  { label: 'Italian', value: 'it-IT', shortCode: 'IT' },
  { label: 'Polish', value: 'pl-PL', shortCode: 'PL' },
  { label: 'Portuguese (Brazil)', value: 'pt-BR', shortCode: 'PT(BR)' },
  { label: 'Spanish', value: 'es-ES', shortCode: 'ES' },
  { label: 'Spanish US', value: 'es-US', shortCode: 'ES(US)' },
] as const

export const basicLanguageOptions = BASIC_LANGUAGES.map((lang) => ({
  label: lang.label,
  value: lang.value,
  selectedLabel: <SelectedLabel text={lang.shortCode} className="justify-center" />,
}))

export const promptSpeakTypeOptions = [
  {
    label: 'Basic',
    value: 'basic',
    selectedLabel: <SelectedLabel icon={Volume2} text="BA" />,
  },
  {
    label: 'Amazon Polly',
    value: 'polly',
    selectedLabel: <SelectedLabel icon={Volume2} text="AP" />,
  },
  {
    label: 'AI Voices',
    value: ProviderTypes.ElevenLabs,
    selectedLabel: <SelectedLabel icon={Volume2} text="AV" />,
  },
]

export const voiceOptions = [
  {
    label: 'Woman',
    value: 'WOMAN',
    selectedLabel: <SelectedLabel icon={AudioLines} text="W" />,
  },
  {
    label: 'Man',
    value: 'MAN',
    selectedLabel: <SelectedLabel icon={AudioLines} text="M" />,
  },
]
